export const JOBSBOARD_TITLE = 'Jobs board';
export const JOBS_TITLE = 'Jobs';
export const CRITERIA_TITLE = 'Criteria';
export const CONTACT_TITLE = 'Get in touch';
export const APPLICANTS_TITLE = 'Applicants';
export const EMPLOYERS_TITLE = 'Employers';
